import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import LandingPage from './component/LandingPage';
import About from "./component/About";
import Contact from "./component/Contact";
import UserProfile from "./component/UserProfile";
import LoginSignUpPage from "./component/LoginSignUpPage";
import LoginChoicePage from "./component/LoginChoicePage";
import TouristLoginPage from "./component/TouristLoginPage";
import PartnerLoginPage from "./component/PartnerLoginPage";
import TouristSignUpPage from "./component/TouristSignUpPage";
import PartnerSignUpPage from "./component/PartnerSignUpPage";
import SignUpChoicePage from "./component/SignUpChoicePage";
import TouristProfilePage from "./component/TouristProfilePage";
import OffersPage from "./component/OffersPage";
import CreateOfferPage from "./component/CreateOfferPage";
import PartnerProfilePage from "./component/PartnerProfilePage";
import DetailOfferPage from "./component/DetailOfferPage";
import AgenciesPage from "./component/AgenciesPage";
import UserOffersPage from "./component/UserOfferPage";
import RestaurantPage from "./component/RestaurantPage";
import CreateRestaurantPage from "./component/CreateRestaurentPage";
import ResidencePage from "./component/ResidencePage";
import CreateResidencePage from "./component/CreateResidencePage";
import TransportOffersPage from "./component/TransportOffersPage";
import CreateTransportOfferPage from "./component/CreateTransportOfferPage";
import TouristGuideOfferCreate from "./component/TouristGuideCreateOffer";
import TouristGuideRegister from "./component/TouristGuideRegister";
import TouristGuides from "./component/TouristGuide";
import TouristGuideLogin from "./component/TouristGuideLogin";
import PublicPathsPage from "./component/PublicPathespage";
import AddPublicPathPage from "./component/AddPublicPathPage";
import TouristResortsPage from "./component/TouristRestorePage";
import AddTouristResortPage from "./component/AddTouristResortsPage";
import HalalMarketsPage from "./component/HalalMarketPage";
import HalalMarketDataEntryPage from "./component/HalalMarketdataEntryPage";
import MosquesPage from "./component/MosquesPage";
import KiblaCompassPage from "./component/KiblaCompassPage";
import PrayerTimesPage from "./component/PrayerTimePage";
import TouristAttractionPage from "./component/TouristAttractionPage";
import RihalOffers from "./component/RihalOffers";
import CreateYourOwnTrip from "./component/CreateYourOwnTrip";
import CreateATripForWomen from "./component/CreateATripForWomen";
import TouristGuidesAgency from "./component/ToursitGuideAgency";
import TouristGuidesCourses from "./component/ToursitGuideCourses";
import ResidenceDetailPage from "./component/ResidenceDetailPage";
import { listenAuthState } from './firebase';


function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Listen to Firebase auth state changes
    const unsubscribe = listenAuthState((user) => {
      if (user) {
        setIsLoggedIn(true); // User is logged in
      } else {
        setIsLoggedIn(false); // User is logged out
      }
    });

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, []);

  return (
    <Router>
  
      
      <Routes>
        {/* Routes */}
        <Route path="/" element={isLoggedIn ? <LandingPage /> : <LoginSignUpPage />} />
        <Route path="/Aboutus" element={<About />} />
        <Route path="/Contactus" element={<Contact />} />
        <Route path="/UserProfile" element={<UserProfile />} />
        <Route path="/LoginSignUpPage" element={<LoginSignUpPage />} />
        <Route path="/LoginChoicePage" element={<LoginChoicePage />} />
        <Route path="/TouristLoginPage" element={<TouristLoginPage />} />
        <Route path="/PartnerLoginPage" element={<PartnerLoginPage />} />
        <Route path="/SignUpChoicePage" element={<SignUpChoicePage />} />
        <Route path="/TouristSignUpPage" element={<TouristSignUpPage />} />
        <Route path="/PartnerSignUpPage" element={<PartnerSignUpPage />} />
        <Route path="/tourist-profile" element={<TouristProfilePage />} />
        <Route path="/OffersPage" element={<OffersPage />} />
        <Route path="/CreateOfferPage" element={<CreateOfferPage />} />
        <Route path="/partner-profile" element={<PartnerProfilePage />} />
        <Route path="/OffersPage/:offerId" element={<DetailOfferPage />} />
        <Route path="/AgenciesPage" element={<AgenciesPage />} />
        <Route path="/user/:userId/offers" element={<UserOffersPage />} />
        <Route path="/Restaurant" element={<RestaurantPage />} />
        <Route path="/CreateRestaurantPage" element={<CreateRestaurantPage />} />
        <Route path="/ResidencePage" element={<ResidencePage />} />
        <Route path="/CreateResidencePage" element={<CreateResidencePage />} />
        <Route path="/TransportOffersPage" element={<TransportOffersPage />} />
        <Route path="/CreateTransportOfferPage" element={<CreateTransportOfferPage />} />
        <Route path="/tourist-guides" element={<TouristGuides />} />
        <Route path="/tourist-guide-register" element={<TouristGuideRegister />} />
        <Route path="/tourist-guide-create-offer" element={<TouristGuideOfferCreate />} />
        <Route path="/tourist-guide-login" element={<TouristGuideLogin />} />
        <Route path="/Public-Bathes" element={<PublicPathsPage />} />
        <Route path="/AddPublicPath" element={<AddPublicPathPage />} />
        <Route path="/touristResorts" element={<TouristResortsPage />} />
        <Route path="/addtouristResorts" element={<AddTouristResortPage />} />
        <Route path="/Shopping" element={<HalalMarketsPage />} />
        <Route path="/addshops" element={<HalalMarketDataEntryPage />} />
        <Route path="/Mosques" element={<MosquesPage />} />
        <Route path="/KiblaCompass" element={<KiblaCompassPage />} />
        <Route path="/PrayerTimePage" element={<PrayerTimesPage />} />
        <Route path="/TouristAttractionPage" element={<TouristAttractionPage />} />
        <Route path="/RihalOffers" element={<RihalOffers />} />
        <Route path="/CreateYourOwnTrip" element={<CreateYourOwnTrip />} />
        <Route path="/CreateATripForWomen" element={<CreateATripForWomen />} />
        <Route path="/tourist-guides-agency" element={<TouristGuidesAgency />} />
        <Route path="/tourist-guides-courses-and-formation" element={<TouristGuidesCourses />} />
        <Route path="/residence/:id" element={<ResidenceDetailPage />} />
     
      </Routes>
    </Router>
  );
}

export default App;

